const SocketEvent = {
  INPUT_SOURCE_CREATION_EVENT_NAME: 'Transaction Source Creation',
  INPUT_CONFIG_FILE_UPLOAD_EVENT_NAME: 'Transaction Source File Upload',
  INPUT_CUSTOM_COLUMN_CREATION_EVENT_NAME: 'Transaction Derived Field Creation',

  MASTER_SOURCE_CREATION_EVENT_NAME: 'Master Data Source Creation',
  MASTER_CONFIG_FILE_UPLOAD_EVENT_NAME: 'Master Source File Upload',

  UNIFIED_SOURCE_CREATION_EVENT_NAME: 'Unified Source Creation',
  UNIFIED_SOURCE_UPDATE_EVENT_NAME: 'Unified Data Configuration Update',
  UNIFIED_CUSTOM_COLUMN_CREATION_EVENT_NAME: 'Unified Derived Field Creation',
};

export default SocketEvent;
